<div *ngIf="loading; else langingBlock">
  <div class="d-flex justify-content-center align-items-center" style="height: 100vh">
    <div class="spinner-border text-primary" role="status" style="width: 4rem; height: 4rem">
      <span class="sr-only">Loading...</span>
    </div>
  </div>
</div>
<ng-template #langingBlock>
  <div class="d-flex flex-column min-vh-100">
    <app-header-buscador></app-header-buscador>
    <ng-container *ngIf="query && config?.theme != 3">
      <div class="container d-flex align-items-center mt-2" style="gap: 18px" *ngIf="query">
        <button
          (click)="borrarFiltro()"
          [style]="'background-color:' + config?.primaryColor + '; color:' + config.secondaryColor"
          class="btn"
        >
          Borrar Filtros
        </button>
        <h4 class="m-0">Existen Filtros aplicados a tu busqueda</h4>
      </div>
    </ng-container>
    <ng-container *ngIf="config?.theme && config?.theme === 1">
      <div class="container-lg container-md container-xl">
        <div class="row card-group">
          <div *ngIf="loadingProperties; else propertiesBlock" class="w-100">
            <div class="d-flex justify-content-center align-items-center" style="height: 50vh">
              <div
                class="spinner-border"
                [style]="'color:' + config?.primaryColor + ' !important;'"
                role="status"
                style="width: 4rem; height: 4rem"
              >
                <span class="sr-only">Loading...</span>
              </div>
            </div>
          </div>
          <ng-template #propertiesBlock>
            <div
              class="col-12 col-md-4 col-lg-4 col-xl-4 col-sm-12 offset-md-4 offset-lg-4 offset-xl-4 my-2"
              *ngIf="properties.length < 1"
            >
              <div class="card text-center">
                <div class="card-body">
                  <h4 class="card-title">Aún no hay propiedades disponibles.</h4>
                  <p class="card-text">
                    Aún no contamos con propiedades publicadas. Mantente al pendiente de las nuevas publicaciones.
                  </p>
                </div>
              </div>
            </div>

            <div class="col-md-6 col-lg-3 col-xl-3 col-12 my-2" *ngFor="let pro of properties">
              <div class="card cardBloque h-90 w-100">
                <ng-container *ngIf="pro.project === undefined || pro.project === null">
                  <img
                    [src]="pro.principalPath"
                    class="card-img-top img-fluid rounded ptn"
                    alt="Random first slide"
                    (click)="verDetalles(pro.id)"
                    (error)="pro.principalPath = 'assets/images/noImage.png'"
                  />
                  <div class="card-body ptn" style="height: min-content">
                    <p class="card-subtitle">
                      <small class="text-muted" (click)="verDetalles(pro.id)"
                        >{{ pro.province?.name }}, {{ pro.state.name }}</small
                      >
                    </p>
                    <h4 class="card-title" (click)="verDetalles(pro.id)" style="height: 42px; overflow: hidden">
                      {{ pro.title }}
                    </h4>
                    <div class="row" (click)="verDetalles(pro.id)" style="text-align: end">
                      <div class="col-12 mt-sm-1 mt-md-1 mt-1">
                        <h4 class="card-subtitle" [style]="'color:' + config?.primaryColor + ' !important;'">
                          {{ pro.price | customCurrency }} {{ getCoinTypeName(pro.coin_type) }}
                        </h4>
                      </div>
                    </div>

                    <div class="typeProperty" *ngIf="pro.property_type">
                      <div
                        class="badge my-badge"
                        style="border-radius: 15px"
                        [style]="'background-color:' + config?.primaryColor + ';'"
                      >
                        {{ pro.property_type?.name }}
                      </div>
                    </div>
                  </div>
                </ng-container>
                <ng-container *ngIf="pro.project !== null && pro.project !== undefined">
                  <img
                    [src]="pro?.project?.files[0]?.url"
                    class="card-img-top img-fluid rounded ptn"
                    alt="Random first slide"
                    (click)="verProyecto(pro?.project?.id, pro?.project?.real_estate_id)"
                    (error)="pro.project.files[0].url = 'assets/images/noImage.png'"
                  />
                  <div class="card-body ptn" style="height: min-content">
                    <p class="card-subtitle">
                      <small class="text-muted" (click)="verProyecto(pro?.project?.id, pro?.project?.real_estate_id)">{{
                        pro?.project?.location
                      }}</small>
                    </p>
                    <h4
                      class="card-title"
                      (click)="verProyecto(pro?.project?.id, pro?.project?.real_estate_id)"
                      style="height: 42px; overflow: hidden"
                    >
                      {{ pro?.project?.name }}
                    </h4>
                    <div
                      class="row"
                      (click)="verProyecto(pro?.project?.id, pro?.project?.real_estate_id)"
                      style="text-align: end"
                    >
                      <div class="col-12 mt-sm-1 mt-md-1 mt-1">
                        <h4 class="card-subtitle" [style]="'color:' + config?.primaryColor + ' !important;'">
                          {{ pro?.project?.min_price_estate | customCurrency }} -
                          {{ pro?.project?.max_price_estate | customCurrency }}
                        </h4>
                      </div>
                    </div>

                    <div class="typeProperty">
                      <div
                        class="badge my-badge"
                        style="border-radius: 15px"
                        [style]="'background-color:' + config?.primaryColor + ';'"
                      >
                        Desarrollo
                      </div>
                    </div>
                  </div>
                </ng-container>
              </div>
            </div>
          </ng-template>
        </div>

        <!--BTN PARA WHATS-->
        <div class="contactBtn" *ngIf="config.phoneWhatsApp">
          <div class="d-flex justify-content-center">
            <div class="container-whats mt-1" (click)="sendWhatsApp()">
              <div class="contour">
                <img
                  *ngIf="config?.logo"
                  [src]="config?.logo"
                  alt="Imagen superpuesta"
                  width="100%"
                  height="100%"
                  style="border-radius: 100%"
                />
                <img
                  *ngIf="!config?.logo"
                  src="r../../../../../assets/images/phone2.png"
                  alt="Imagen superpuesta"
                  width="100%"
                  height="100%"
                  class="fas"
                />
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="offset-md-7 col-md-5 offset-sm-0 col-12">
            <div class="d-flex justify-content-between float-right m-1">
              <ngb-pagination
                [collectionSize]="sizeTable"
                [maxSize]="3"
                [rotate]="true"
                [(page)]="page"
                [pageSize]="pageSize"
                (pageChange)="onPageChange()"
                aria-label="Cambiar página"
              >
                <ng-template ngbPaginationPrevious
                  ><span
                    [data-feather]="'chevron-left'"
                    [size]="18"
                    [class]="'font-weight-bolder'"
                    [style]="'color:' + config?.primaryColor + ' !important;'"
                  ></span>
                </ng-template>
                <ng-template ngbPaginationNext
                  ><span
                    [data-feather]="'chevron-right'"
                    [size]="18"
                    [class]="'font-weight-bolder'"
                    [style]="'color:' + config?.primaryColor + ' !important;'"
                  ></span>
                </ng-template>
              </ngb-pagination>
            </div>
          </div>
        </div>
        <br />
        <br />
        <br />
      </div>
    </ng-container>

    <ng-container *ngIf="config?.theme && config?.theme === 2">
      <div class="container-lg container-md container-xl">
        <div class="row card-group">
          <div *ngIf="loadingProperties; else propertiesBlock" class="w-100">
            <div class="d-flex justify-content-center align-items-center" style="height: 50vh">
              <div
                class="spinner-border"
                [style]="'color:' + config?.primaryColor + ' !important;'"
                role="status"
                style="width: 4rem; height: 4rem"
              >
                <span class="sr-only">Loading...</span>
              </div>
            </div>
          </div>
          <ng-template #propertiesBlock>
            <div
              class="col-12 col-md-4 col-lg-4 col-xl-4 col-sm-12 offset-md-4 offset-lg-4 offset-xl-4 my-2"
              *ngIf="properties.length < 1"
            >
              <div class="card text-center">
                <div class="card-body">
                  <h4 class="card-title">Aún no hay propiedades disponibles.</h4>
                  <p class="card-text">
                    Aún no contamos con propiedades publicadas. Mantente al pendiente de las nuevas publicaciones.
                  </p>
                </div>
              </div>
            </div>

            <div class="col-12 d-flex justify-content-center mt-1">
              <img
                [src]="config?.logo"
                class="img-fluid imgPortLogo"
                alt="LOGO"
                [style]="'border: 10px solid' + config?.primaryColor + '; border-radius: 20px; '"
              />
            </div>

            <div class="col-12 text-center mt-2">
              <h1 [style]="'color:' + config?.primaryColor + ';'">Listado de nuestras propiedades</h1>
            </div>

            <div class="col-md-6 col-lg-4 col-xl-4 col-12 my-2" *ngFor="let pro of properties">
              <div
                class="card cardBloque h-90 w-100"
                [style]="'border: 5px solid' + config?.primaryColor + '50; border-radius: 30px;'"
              >
                <ng-container *ngIf="pro.project === undefined || pro.project === null">
                  <img
                    [src]="pro.principalPath"
                    class="card-img-top img-fluid rounded ptn"
                    alt="Random first slide"
                    (click)="verDetalles(pro.id)"
                    (error)="pro.principalPath = 'assets/images/noImage.png'"
                    style="border-radius: 25px 25px 0px 0px !important"
                  />
                  <div class="card-body ptn" style="height: min-content">
                    <div class="row" style="text-align: end" (click)="verDetalles(pro.id)">
                      <div class="col-12 col-md-3 mt-1 mt-md-0 text-center" *ngIf="pro.property_type">
                        <div
                          class="badge my-badge"
                          [style]="'border-radius: 15px; background-color:' + config?.primaryColor + ';'"
                        >
                          {{ pro.property_type?.name }}
                        </div>
                      </div>

                      <div class="col-12 col-md-9 mt-1 mt-md-0">
                        <h4 [style]="'color:' + config?.primaryColor + ';'">
                          {{ pro.price | customCurrency }} {{ getCoinTypeName(pro.coin_type) }}
                        </h4>
                      </div>
                    </div>

                    <p class="card-subtitle mt-1">
                      <small class="text-muted" (click)="verDetalles(pro.id)"
                        >{{ pro.province?.name }}, {{ pro.state.name }}</small
                      >
                    </p>
                    <h4 class="card-title" (click)="verDetalles(pro.id)" style="height: 42px; overflow: hidden">
                      {{ pro.title }}
                    </h4>
                  </div>
                </ng-container>
                <ng-container *ngIf="pro.project !== null && pro.project !== undefined">
                  <img
                    [src]="pro?.project?.files[0]?.url"
                    class="card-img-top img-fluid rounded ptn"
                    alt="Random first slide"
                    (click)="verProyecto(pro?.project?.id, pro?.project?.real_estate_id)"
                    (error)="pro.project.files[0].url = 'assets/images/noImage.png'"
                    style="border-radius: 25px 25px 0px 0px !important"
                  />
                  <div class="card-body ptn" style="height: min-content">
                    <div
                      class="row"
                      style="text-align: end"
                      (click)="verProyecto(pro?.project?.id, pro?.project?.real_estate_id)"
                    >
                      <div class="col-12 col-md-3 mt-1 mt-md-0 text-center">
                        <div
                          class="badge my-badge"
                          [style]="'border-radius: 15px; background-color:' + config?.primaryColor + ';'"
                        >
                          Desarrollo
                        </div>
                      </div>

                      <div class="col-12 col-md-9 mt-1 mt-md-0">
                        <h4 [style]="'color:' + config?.primaryColor + ';'">
                          {{ pro?.project?.min_price_estate | customCurrency }} -
                          {{ pro?.project?.max_price_estate | customCurrency }}
                        </h4>
                      </div>
                    </div>

                    <p class="card-subtitle mt-1">
                      <small class="text-muted" (click)="verProyecto(pro?.project?.id, pro?.project?.real_estate_id)">{{
                        pro?.project?.location
                      }}</small>
                    </p>
                    <h4
                      class="card-title"
                      (click)="verProyecto(pro?.project?.id, pro?.project?.real_estate_id)"
                      style="height: 42px; overflow: hidden"
                    >
                      {{ pro?.project?.name }}
                    </h4>
                  </div>
                </ng-container>
              </div>
            </div>
          </ng-template>
        </div>

        <div class="contactBtn" *ngIf="config.phoneWhatsApp">
          <div class="d-flex justify-content-center">
            <div class="container-whats mt-1" (click)="sendWhatsApp()">
              <div class="contour">
                <img
                  *ngIf="config?.logo"
                  [src]="config?.logo"
                  alt="Imagen superpuesta"
                  width="100%"
                  height="100%"
                  style="border-radius: 100%"
                />
                <img
                  *ngIf="!config?.logo"
                  src="r../../../../../assets/images/phone2.png"
                  alt="Imagen superpuesta"
                  width="100%"
                  height="100%"
                  class="fas"
                />
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="offset-md-7 col-md-5 offset-sm-0 col-12">
            <div class="d-flex justify-content-between float-right m-1">
              <ngb-pagination
                [collectionSize]="sizeTable"
                [maxSize]="3"
                [rotate]="true"
                [(page)]="page"
                [pageSize]="pageSize"
                (pageChange)="onPageChange()"
                aria-label="Cambiar página"
              >
                <ng-template ngbPaginationPrevious
                  ><span
                    [data-feather]="'chevron-left'"
                    [size]="18"
                    [class]="'font-weight-bolder'"
                    [style]="'color:' + config?.primaryColor + ' !important;'"
                  ></span>
                </ng-template>
                <ng-template ngbPaginationNext
                  ><span
                    [data-feather]="'chevron-right'"
                    [size]="18"
                    [class]="'font-weight-bolder'"
                    [style]="'color:' + config?.primaryColor + ' !important;'"
                  ></span>
                </ng-template>
              </ngb-pagination>
            </div>
          </div>
        </div>
        <br />
        <br />
        <br />
        <br />
        <br />
      </div>
    </ng-container>

    <ng-container *ngIf="config?.theme && config?.theme === 3">
      <div class="imgPortCarrusel" *ngIf="propertiesRand">
        <swiper class="swiper-fade-effect swiper-container mt-1" [config]="swiperFadeEffect">
          <div
            *ngFor="let pro of propertiesRand"
            [style]="
              'height: auto; width: auto; background-image: url(' +
              pro.principalPath +
              '); background-size: cover;
                        background-position:center;'
            "
            class="d-flex justify-content-center align-items-center"
          >
            <div
              style="background-color: #ffffffee; width: fit-content; height: fit-content"
              class="text-center round ptn"
              (click)="verDetalles(pro.id)"
            >
              <div class="containerText">
                <span class="textCarousselTitle">{{ pro.title }}</span>
                <br />
                <span class="textCarousselSubTitle" [innerHTML]="'> ' + pro.operationType + ' <'"> </span>
                <br />
                <button
                  type="button"
                  class="btn round"
                  rippleEffect
                  [style]="'background-color:' + config?.primaryColor + '; color:' + config.secondaryColor"
                >
                  <span class="textCarousselPrice"
                    >{{ pro.price | customCurrency }} {{ getCoinTypeName(pro.coin_type) }}</span
                  >
                </button>
              </div>
            </div>
          </div>
        </swiper>
      </div>

      <div class="container d-flex align-items-center mt-2" style="gap: 18px" *ngIf="query">
        <button
          (click)="borrarFiltro()"
          [style]="'background-color:' + config?.primaryColor + '; color:' + config.secondaryColor"
          class="btn"
        >
          Borrar Filtros
        </button>
        <h4 class="m-0">Existen Filtros aplicados a tu busqueda</h4>
      </div>

      <div class="container-lg container-md container-xl">
        <div class="row card-group">
          <div *ngIf="loadingProperties; else propertiesBlock" class="w-100">
            <div class="d-flex justify-content-center align-items-center" style="height: 50vh">
              <div
                class="spinner-border"
                [style]="'color:' + config?.primaryColor + ' !important;'"
                role="status"
                style="width: 4rem; height: 4rem"
              >
                <span class="sr-only">Loading...</span>
              </div>
            </div>
          </div>
          <ng-template #propertiesBlock>
            <div
              class="col-12 col-md-4 col-lg-4 col-xl-4 col-sm-12 offset-md-4 offset-lg-4 offset-xl-4 my-2"
              *ngIf="properties.length < 1"
            >
              <div class="card text-center">
                <div class="card-body">
                  <h4 class="card-title">Aún no hay propiedades disponibles.</h4>
                  <p class="card-text">
                    Aún no contamos con propiedades publicadas. Mantente al pendiente de las nuevas publicaciones.
                  </p>
                </div>
              </div>
            </div>

            <div class="col-12 mt-2">
              <div class="card cardBloque" style="border-radius: 5px">
                <div class="card-body mb-1" style="height: min-content">
                  <button
                    type="button"
                    class="btn btn-icon smallTumb"
                    rippleEffect
                    (click)="changeCol(1)"
                    [style]="'background-color:' + config?.primaryColor"
                  >
                    <img src="../../../../../assets/icon/thumb2.png" alt="" width="25px" height="25px" />
                  </button>
                  <button
                    type="button"
                    class="btn btn-icon ml-1 mediumTumb"
                    rippleEffect
                    (click)="changeCol(2)"
                    [style]="'background-color:' + config?.primaryColor"
                  >
                    <img src="../../../../../assets/icon/thumb3.png" alt="" width="25px" height="25px" />
                  </button>
                  <button
                    type="button"
                    class="btn btn-icon ml-1 bigTumb"
                    rippleEffect
                    (click)="changeCol(3)"
                    [style]="'background-color:' + config?.primaryColor"
                  >
                    <img src="../../../../../assets/icon/thumb4.png" alt="" width="25px" height="25px" />
                  </button>
                </div>
              </div>
            </div>

            <div
              [ngClass]="{
                'col-sm-6 col-12': pageSize == 4,
                'col-md-4 col-12': pageSize == 9,
                'col-md-6 col-lg-3 col-xl-3 col-12': pageSize == 8
              }"
              *ngFor="let pro of properties"
            >
              <div class="card cardBloque h-90 w-100" style="border-radius: 30px; overflow: hidden">
                <ng-container *ngIf="pro.project === undefined || pro.project === null">
                  <img
                    [src]="pro.principalPath"
                    class="card-img-top img-fluid rounded ptn"
                    alt="Random first slide"
                    style="border-radius: 25px 25px 0px 0px !important"
                    (click)="verDetalles(pro.id)"
                    (error)="pro.principalPath = 'assets/images/noImage.png'"
                  />
                  <div class="card-body">
                    <h2 style="height: 60px; overflow: hidden">
                      {{ pro.title }}
                    </h2>
                    <i [innerHTML]="'> ' + pro.code" style="font-size: 15px"> </i>
                    <div class="row mt-1">
                      <div class="col-12 mt-sm-1 mt-md-1 mt-1">
                        <h4 class="card-subtitle text-primary">
                          {{ pro.price | customCurrency }} {{ getCoinTypeName(pro.coin_type) }}
                        </h4>
                      </div>
                    </div>

                    <div class="typePropertyT3" *ngIf="pro.property_type">
                      <div
                        class="badge my-badge"
                        [style]="'border-radius: 15px; background-color:' + config?.primaryColor"
                      >
                        {{ pro.property_type?.name }}
                      </div>
                    </div>

                    <div *ngIf="pro?.property_amenities">
                      <div class="row" style="margin-top: 7px">
                        <div class="col-12 col-md-6">
                          <span [innerHTML]="pro?.property_amenities[3]?.amenity?.name"></span>
                        </div>
                        <div class="col-12 col-md-6 d-flex justify-content-end align-items-end">
                          <span [innerHTML]="pro?.property_amenities[3]?.cantidad | number : '1.0-0'"> </span>
                        </div>
                      </div>

                      <div class="row" style="margin-top: 7px">
                        <div class="col-12 col-md-6">
                          <span [innerHTML]="pro?.property_amenities[4]?.amenity?.name"></span>
                        </div>
                        <div class="col-12 col-md-6 d-flex justify-content-end align-items-end">
                          <span [innerHTML]="pro?.property_amenities[4]?.cantidad | number : '1.0-0'"></span>
                        </div>
                      </div>

                      <div class="row" style="margin-top: 7px">
                        <div class="col-12 col-md-6">
                          <span> Habitaciones</span>
                        </div>
                        <div class="col-12 col-md-6 d-flex justify-content-end align-items-end">
                          <span>{{ pro?.property_amenities[0]?.cantidad | number : "1.0-0" }}</span>
                        </div>
                      </div>

                      <div class="row" style="margin-top: 7px">
                        <div class="col-12 col-md-6">
                          <span> Baños</span>
                        </div>
                        <div class="col-12 col-md-6 d-flex justify-content-end align-items-end">
                          <!-- Imprimir pro?.property_amenities[1]?.cantidad pero que el resultado no tenga ceros despues del punto decimal, a menos que tenga decimales -->
                          <span>{{ pro?.property_amenities[1]?.cantidad | number : "1.0-2" }}</span>
                        </div>
                      </div>

                      <div class="row" style="margin-top: 7px">
                        <div class="col-12 col-md-6">
                          <span> Amueblado</span>
                        </div>
                        <div class="col-12 col-md-6 d-flex justify-content-end align-items-end">
                          <span> {{ getAmenidadAmueblado(pro?.property_amenities) ? "Si" : "No" }}</span>
                        </div>
                      </div>
                    </div>
                    <button
                      type="button"
                      class="btn"
                      rippleEffect
                      (click)="verDetalles(pro.id)"
                      [style]="
                        'margin-top: 8px; margin-bottom: 10px; background-color:' +
                        config?.primaryColor +
                        '; color:' +
                        config.secondaryColor
                      "
                    >
                      Ver propiedad
                    </button>
                  </div>
                </ng-container>
                <ng-container *ngIf="pro.project !== null && pro.project !== undefined">
                  <img
                    [src]="pro?.project?.files[0]?.url"
                    class="card-img-top img-fluid rounded ptn"
                    alt="Random first slide"
                    style="border-radius: 25px 25px 0px 0px !important"
                    (click)="verProyecto(pro?.project?.id, pro?.project?.real_estate_id)"
                    (error)="pro.project.files[0].url = 'assets/images/noImage.png'"
                  />
                  <div class="card-body">
                    <h2 style="height: 60px; overflow: hidden">
                      {{ pro?.project?.name }}
                    </h2>
                    <i [innerHTML]="'> ' + pro.code" style="font-size: 15px"> </i>
                    <div class="row mt-1">
                      <div class="col-12 mt-sm-1 mt-md-1 mt-1">
                        <h4 class="card-subtitle text-primary">
                          {{ pro?.project?.min_price_estate | customCurrency }} -
                          {{ pro?.project?.max_price_estate | customCurrency }}
                        </h4>
                      </div>
                    </div>

                    <div class="typePropertyT3">
                      <div
                        class="badge my-badge"
                        [style]="'border-radius: 15px; background-color:' + config?.primaryColor"
                      >
                        Desarrollo
                      </div>
                    </div>

                    <div>
                      <div class="row" style="margin-top: 7px">
                        <p style="max-height: 17ch; overflow: hidden" class="px-1 m-0">
                          <span [innerHTML]="pro?.project?.description"></span>
                        </p>
                      </div>
                    </div>
                    <button
                      type="button"
                      class="btn"
                      rippleEffect
                      (click)="verProyecto(pro?.project?.id, pro?.project?.real_estate_id)"
                      [style]="
                        'margin-top: 8px; margin-bottom: 10px; background-color:' +
                        config?.primaryColor +
                        '; color:' +
                        config.secondaryColor
                      "
                    >
                      Ver proyecto
                    </button>
                  </div>
                </ng-container>
              </div>
            </div>
          </ng-template>
        </div>
        <div class="contactBtn" *ngIf="config.phoneWhatsApp">
          <div class="d-flex justify-content-center">
            <div class="container-whats mt-1" (click)="sendWhatsApp()">
              <div class="contour">
                <img
                  *ngIf="config?.logo"
                  [src]="config?.logo"
                  alt="Imagen superpuesta"
                  width="100%"
                  height="100%"
                  style="border-radius: 100%"
                />
                <img
                  *ngIf="!config?.logo"
                  src="r../../../../../assets/images/phone2.png"
                  alt="Imagen superpuesta"
                  width="100%"
                  height="100%"
                  class="fas"
                />
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="offset-md-7 col-md-5 offset-sm-0 col-12">
            <div class="d-flex justify-content-between float-right m-1">
              <ngb-pagination
                [collectionSize]="sizeTable"
                [maxSize]="3"
                [rotate]="true"
                [(page)]="page"
                [pageSize]="pageSize"
                (pageChange)="onPageChange()"
                aria-label="Cambiar página"
              >
                <ng-template ngbPaginationPrevious
                  ><span [data-feather]="'chevron-left'" [size]="18" [class]="'font-weight-bolder text-primary'"></span>
                </ng-template>
                <ng-template ngbPaginationNext
                  ><span
                    [data-feather]="'chevron-right'"
                    [size]="18"
                    [class]="'font-weight-bolder text-primary'"
                  ></span>
                </ng-template>
              </ngb-pagination>
            </div>
          </div>
        </div>
      </div>
    </ng-container>

    <app-footer class="mt-auto"></app-footer>
  </div>
</ng-template>
